module.exports = __webpack_public_path__ + "static/scale-model-of-downtown-sioux-falls-in-sioux-falls-south-dakota-88e20bf42f372e9ec5f62691d290ca1e.png";